<template>
  <a href="#" class="card h-100">
    <div>
      <img src="/images/news/news1.png" alt="" class="card-img"/>
    </div>
    <div class="card-body">
      <h3 class="card-title h5">
        <span class="link stretched-link">Zgłoś swój przejazd - Internetowy formularz</span>
      </h3>
    </div>
    <div class="card-footer">
      <small>
        12.10.2020 16:35
      </small>
    </div>
  </a>
</template>
<script>
export default {
  name: 'news',
  props: {},
  components: {},
  data() {
    return {}
  }
}
</script>